import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Plantilla from "./Plantilla.jsx";
import Resultado from "./Resultado.jsx";
import Error from "./Error.jsx";
import ResultadoDocument from "./ResultadoDocument.jsx";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Plantilla />} />
        <Route path="/resultado" element={<Resultado />} />
        <Route path="/document" element={<ResultadoDocument />} />
        <Route path="/error" element={<Error />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
